
let articleUrl;

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_BASE_NAME === 'production') { // 正式环境
  articleUrl = 'https://yzims.oss-cn-shenzhen.aliyuncs.com/';
} else if (process.env.VUE_APP_BASE_NAME === 'devtest') { // 预发布环境
  articleUrl = 'https://img2.yzwill.cn/'; // 192换oss地址，由原来线上换成img2
} else if (process.env.NODE_ENV === 'development') { // 本地开发
  articleUrl = 'https://yzimstest.oss-cn-shenzhen.aliyuncs.com/';
  articleUrl = 'https://yzims.oss-cn-shenzhen.aliyuncs.com/';
} else { // 测试环境
  articleUrl = 'https://yzimstest.oss-cn-shenzhen.aliyuncs.com/';
}
export default {
  articleUrl
};
